import { Config } from '@langchain/langgraph-sdk';

import { JSONSchema7Definition } from 'json-schema';

import { useGraphAssistantsDebugSchema } from '@/Pages/Graph/src/api/useGraphSwr';
import { getSchemaProperties } from '@/Pages/Graph/src/json-schema-utils';

export const useAssistantDefaultConfigSchema = (
  assistantId?: string
): {
  defaultConfigSchema: Config['configurable'] | undefined;
  schemaError: unknown;
  schemaLoading: boolean;
} => {
  const {
    data: schemas,
    error: schemaError,
    isLoading: schemaLoading,
  } = useGraphAssistantsDebugSchema(assistantId ? [assistantId] : undefined);
  const schema = schemas?.[0];
  if (!schema)
    return { defaultConfigSchema: undefined, schemaError, schemaLoading };
  const { config } = schema;

  const defaultConfigSchema = getDefaultConfigSchema(config);
  return {
    defaultConfigSchema,
    schemaError,
    schemaLoading,
  };
};

export const getDefaultConfigSchema = (
  config: JSONSchema7Definition | null | undefined
) => {
  return Object.entries(getSchemaProperties(config) ?? {}).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: typeof value === 'object' ? value.default : undefined,
    }),
    {}
  );
};
